import { useCallback } from 'react';
import { analyticsService } from '../../../core/services/firebase';

export const useOnboardingAnalytics = () => {
  const logStepView = useCallback((stepId) => {
    analyticsService.logEvent('onboarding_view', {
      step_id: stepId,
      timestamp: Date.now()
    });
  }, []);

  const logStepComplete = useCallback((stepId, data) => {
    analyticsService.logEvent('onboarding_complete_step', {
      step_id: stepId,
      data_collected: Object.keys(data),
      timestamp: Date.now()
    });
  }, []);

  const logOnboardingComplete = useCallback((totalSteps, totalTime) => {
    analyticsService.logEvent('onboarding_complete', {
      total_steps: totalSteps,
      total_time_seconds: totalTime,
      timestamp: Date.now()
    });
  }, []);

  return { logStepView, logStepComplete, logOnboardingComplete };
}; 